import * as types from './types'
import { createReducer } from 'app/state/utils'
import { Document } from 'app/models/document-params'
import { ContractType, DocumentStateTypes } from 'app/models/common-types'

export interface DocumentState {
  dealDocuments?: Document[] | null
  facilityDocuments?: Document[] | null
  entityDocuments?: Document[] | null
  principalDocuments?: Document[] | null
  paymentDocuments?: Document[] | null
  feeDocuments?: Document[] | null
  subTradesDocuments?: Document[] | null
  masterTradeDocuments?: Document[] | null
}

const initialState: DocumentState = {
  dealDocuments: [],
  facilityDocuments: [],
  entityDocuments: [],
  principalDocuments: [],
  paymentDocuments: [],
  feeDocuments: [],
  subTradesDocuments: [],
  masterTradeDocuments: [],
}

const documentsReducer = createReducer(initialState)({
  [types.GET_DOCUMENT_BY_CONTRACT]: (state: any, payload: any) => {
    return {
      ...state,
      dealDocuments:
        payload.payload.type === ContractType.Deals
          ? payload.payload.data
          : state.dealDocuments,
      facilityDocuments:
        payload.payload.type === ContractType.Facilities
          ? payload.payload.data
          : state.facilityDocuments,
      entityDocuments:
        payload.payload.type === ContractType.Entities
          ? payload.payload.data
          : state.entityDocuments,
      principalDocuments:
        payload.payload.type === ContractType.Principals
          ? payload.payload.data
          : state.principalDocuments,
      paymentDocuments:
        payload.payload.type === ContractType.Payments
          ? payload.payload.data
          : state.paymentDocuments,
      feeDocuments:
        payload.payload.type === ContractType.Fees
          ? payload.payload.data
          : state.feeDocuments,
      subTradesDocuments:
        payload.payload.type === ContractType.SubTrades
          ? payload.payload.data
          : state.subTradesDocuments,
      masterTradeDocuments:
        payload.payload.type === ContractType.MasterTrade
          ? payload.payload.data
          : state.masterTradeDocuments,
    }
  },
  [types.UPLOAD_DOCUMENT]: (state: any, payload: any) => {
    return {
      ...state,
      dealDocuments:
        payload.payload.contractType === ContractType.Deals
          ? [...state.dealDocuments, payload.payload]
          : state.dealDocument,
      facilityDocuments:
        payload.payload.contractType === ContractType.Facilities
          ? [...state.facilityDocuments, payload.payload]
          : state.facilityDocument,
      entityDocuments:
        payload.payload.contractType === ContractType.Entities
          ? [...state.entityDocuments, payload.payload]
          : state.entityDocument,
      principalDocuments:
        payload.payload.contractType === ContractType.Principals
          ? [...state.principalDocuments, payload.payload]
          : state.principalDocument,
      paymentDocuments:
        payload.payload.contractType === ContractType.Payments
          ? [...state.paymentDocuments, payload.payload]
          : state.paymentDocument,
      feeDocuments:
        payload.payload.contractType === ContractType.Fees
          ? [...state.feeDocuments, payload.payload]
          : state.feeDocument,
      subTradesDocuments:
        payload.payload.contractType === ContractType.SubTrades
          ? [...state.subTradesDocuments, payload.payload]
          : state.subTradesDocuments,
      masterTradeDocuments:
        payload.payload.contractType === ContractType.SubTrades
          ? [...state.masterTradeDocuments, payload.payload]
          : state.masterTradeDocuments,
    }
  },
  [types.EDIT_DOCUMENT_TAG]: (state: any, payload: any) => {
    const documentStateType =
      DocumentStateTypes[payload.payload.contractType as ContractType]
    const documents = state[documentStateType]
    const index = documents.findIndex(
      (document: any) => document.id === payload.payload.id,
    )
    const newArray = [...state.documents]
    newArray[index] = payload.payload
    return {
      ...state,
      [documentStateType]: newArray,
    }
  },
  [types.UPDATE_DOCUMENT_TYPE]: (state: any, payload: any) => {
    const documentStateType =
      DocumentStateTypes[payload.payload.contractType as ContractType]
    const documents = state[documentStateType]
    const index = documents.findIndex(
      (document: any) => document.id === payload.payload.id,
    )
    if (index === -1) {
      return state // Document not found, return unchanged state
    }
    const newArray = [...state[documentStateType]]
    newArray[index] = {
      ...newArray[index],
      documentType: payload.payload.documentType,
      documentTypeText: payload.payload.documentTypeText,
    }
    return {
      ...state,
      [documentStateType]: newArray,
    }
  },
  [types.REMOVE_DOCUMENT]: (state: any, payload: any) => {
    if (payload.payload.data.length === 0) {
      return state
    }
    payload.payload.data.forEach(
      (data: { id: any; contractType: ContractType }) => {
        Object.values(DocumentStateTypes).forEach((documentStateType: any) => {
          const documents = state[documentStateType]
          const index = (documents ?? []).findIndex(
            (document: { id: any }) => document.id === data.id,
          )
          if (index >= 0) {
            documents.splice(index, 1)
          }
        })
      },
    )
    return {
      ...state,
    }
  },
})

export default documentsReducer
